module.exports = __webpack_public_path__ + "static/media/service15.f6f904c8.jpg";